import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Users2, Plus, Trash2, Save } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function CaregiverManager({ patientId }) {
    const [links, setLinks] = useState([]);
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const load = async () => {
        const { data } = await api.get(`/caregivers/patient/${patientId}`);
        setLinks(data);
    };
    useEffect(() => { if (patientId) load(); }, [patientId]);

    const add = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/caregivers/link", { patient_id: patientId, caregiver_email: email });
            toast.success("Cuidador vinculado");
            setEmail("");
            await load();
        } catch (err) { toast.error(formatApiError(err)); }
        finally { setLoading(false); }
    };

    const remove = async (id) => {
        await api.delete(`/caregivers/${id}`);
        toast.success("Vínculo removido"); await load();
    };

    return (
        <div className="card-earthy">
            <div className="flex items-center gap-2 mb-3">
                <Users2 size={18} className="text-brand" />
                <h3 className="font-display text-lg font-medium text-brand">Cuidadores vinculados</h3>
            </div>
            {links.length === 0 ? (
                <p className="text-sm text-muted-clinical mb-4">Nenhum cuidador vinculado. Adicione pelo e-mail (o cuidador deve ter cadastro).</p>
            ) : (
                <ul className="space-y-2 mb-4">
                    {links.map((l) => (
                        <li key={l.id} data-testid={`caregiver-link-${l.id}`} className="flex items-center justify-between p-2 rounded-lg bg-alt">
                            <div>
                                <div className="text-sm font-medium text-brand">{l.caregiver_name}</div>
                                <div className="text-xs text-muted-clinical">{l.caregiver_email}</div>
                            </div>
                            <button onClick={() => remove(l.id)} className="text-[var(--status-danger)] p-1.5 hover:bg-white rounded"><Trash2 size={14} /></button>
                        </li>
                    ))}
                </ul>
            )}
            <form onSubmit={add} className="flex gap-2">
                <input
                    data-testid="caregiver-email-input"
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="cuidador@email.com"
                    className="input-clinical flex-1"
                />
                <button data-testid="caregiver-add-btn" disabled={loading} className="btn-primary"><Plus size={14} /> Vincular</button>
            </form>
        </div>
    );
}
